import { tWithKeyAttr as t } from "../../i18nHelper";
import React, { useEffect, useState } from "react";
import styles from "./voiceMessageButton.module.css";
import Tooltip from "../tooltip/tooltip";

interface VoiceMessageButtonProps {
  onSend: () => void;
  onStart?: () => void;
  onStop: () => void;
  onDelete: () => void;
  isRecording: boolean;
  audioURL: string | null;
  disabled?: boolean;
}

const VoiceMessageButton: React.FC<VoiceMessageButtonProps> = ({
  onSend,
  onStart = () => {},
  onStop,
  onDelete,
  isRecording,
  audioURL,
  disabled,
}) => {
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;
    if (isRecording) {
      interval = setInterval(() => setTimer((t) => t + 1), 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
      setTimer(0);
    };
  }, [isRecording]);

  if (audioURL) {
    return (
      <div className={`${styles.voiceMessageContainer} ${styles.audioMode}`}>
        <button
          type="button"
          data-testid="delete-voice-message"
          className={`${styles.button} ${styles.button_type_delete}`}
          onClick={onDelete}
        />
        <audio className={styles.audio} controls src={audioURL} />
        <button
          type="button"
          data-testid="send-voice-message"
          className={`${styles.button} ${styles.button_type_send}`}
          onClick={onSend}
        />
      </div>
    );
  }

  return (
    <div className={styles.voiceMessageContainer}>
      <button
        type="button"
        data-testid="start-stop-voice-message"
        className={`${styles.button} ${
          isRecording ? styles.button_type_stop : styles.button_type_record
        }`}
        onClick={isRecording ? onStop : onStart}
        disabled={disabled}
      >
        <Tooltip isShown={false} position={"center"}>
          {isRecording ? t('STOP_RECORDING') : t('RECORD_VOICE_MESSAGE')}
        </Tooltip>
      </button>
      {isRecording && (
        <div className={styles.timer}>
          <span>{`${Math.floor(timer / 60)}:${timer % 60 < 10 ? "0" : ""}${
            timer % 60
          }`}</span>
        </div>
      )}
    </div>
  );
};

export default VoiceMessageButton;
